
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'card',
  props: ['imageName', 'title', 'objectPosition', 'sign'],
})
export default class Card extends Vue {}
